import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  MenuItem,
  Paper,
  Switch,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { useEffect, useLayoutEffect, useMemo, useState } from "react";
import axios from "axios";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import NotificationToaste from "../global/NotificationToaste";
import JobAuthorizeComponent from "./JobAuthorizeComponent";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { Receipt } from "@mui/icons-material";
import ReportDialog from "../reports/ReportDialog";
import LoadingBackDrop from "../global/LoadingBackDrop";
import { getPayload, setPutPayload } from "../../services/api";
import ConfirmationDialog from "../global/ConfirmationDialog";
import PDFViewerDialog from "../jasperReports/PDFViewerDialog";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box justifyItems="center" sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const JobAuthorize = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [loading, setLoading] = useState(false);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [completedJobs, setCompletedJobs] = useState([]);
  const [confirmMessage, setConfirmMessage] = useState(
    "Are you sure you want to approve the report?",
  );
  const handleCloseDialog = () => {
    setOpenConfirmDialog(false);
  };
  const loggedUser = JSON.parse(localStorage.getItem("user"));
  const [checkedReport, setCheckedReport] = useState("APPROVE");
  const [pendingRequestsDataEntry, setPendingRequestsDataEntry] = useState([]);
  const [pendingRequestsTO, setPendingRequestsTO] = useState([]);
  const [returnedReports, setReturnedReports] = useState([]);

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [selectedRequestId, setSelectedRequestId] = useState({});
  const [openReportPreviewDialog, setOpenReportPreviewDialog] = useState(false);
  const [data, setData] = useState([]);
  const [letterHead, setLetterHead] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [approveDate, setApproveDate] = useState();
  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  // const loggedUser = JSON.parse(localStorage.getItem("user"));
  useEffect(() => {
    loadBasicData();
  }, [message]);
  const label = { inputProps: { "aria-label": "Size switch demo" } };
  const loadBasicData = async () => {
    setLoading(true);

    await getPayload
      .getPayloadData("/labReq/engineer/all/assignedJobsEngineer")
      .then(function (response) {
        // console.log("this is response data -------------", response.data);
        setCompletedJobs(response.data.pendingRequests);
        setData(response.data.allReports);
        setPendingRequestsDataEntry(response.data.pendingRequestsDataEntry);
        setPendingRequestsTO(response.data.pendingRequestsTO);
        setReturnedReports(response.data.returnedReports);
        // console.log("tabledata", response.data.tableData);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const apprveSelectedRequestDB = async () => {
    setLoading(true);

    // console.log("this is data ", data);

    data.finalized = 1;
    data.authorizedDate = approveDate;

    const sendData = {
      id: selectedRequestId.id,
      authorizedDate: approveDate,
      authorizedBy: { id: 1 },
    };
    // console.log("this is send data ", sendData);
    setOpenConfirmDialog(false);
    await setPutPayload
      .setPayloadData("/labReq/finalize/report", sendData)
      .then(function (response) {
        // console.log(response.data);
        let smsStatus = response.data.smsSent
          ? "SMS sent successfully"
          : "SMS sending failed";

        setMessage(
          "Job : " +
            selectedRequestId.labRequest.year +
            "/" +
            selectedRequestId.labRequest.autoIdByYear +
            " approved successfully..! " +
            smsStatus,
        );

        setMessageType(response.data.smsSent ? "success" : "warning");

        setCompletedJobs(response.data.pendingRequests);
        setData(response.data.allReports);
        setPendingRequestsTO(response.data.pendingRequestsTO);
        setReturnedReports(response.data.returnedReports);

        setLoading(false);
        setOpen(true);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleOpenReportPreview = () => {
    setOpenReportPreviewDialog(true);
  };
  const handleCloseReportPreview = () => {
    setOpenReportPreviewDialog(false);
  };

  //---------------------------------------------------------------Submit by Engineer-------------------------------------------

  //should be memoized or stable
  const columnsSubmitToEng = useMemo(
    () => [
      {
        accessorFn: (row) =>
          `${row.labRequest.year}/${String(
            row.labRequest.autoIdByYear,
          ).padStart(4, "0")}`,
        //accessorKey: "institute.instituteName", //access nested data with dot notation
        header: "Job No",
        size: 80,
      },
      {
        accessorKey: "labRequest.regDate",
        header: "Job Date",
        size: 80,
      },
      {
        accessorKey: "labRequest.institute.instituteName", //access nested data with dot notation
        header: "Institute / Contractor",
        size: 200,
      },

      {
        accessorFn: (row) =>
          `QC/${row.reportType}/${row.labRequest.year}/${String(
            row.id,
          ).padStart(4, "0")}`,
        header: "Report No",
        size: 80,
      },
      {
        accessorKey: "date",
        header: "Report Date",
        size: 80,
      },
      {
        accessorKey: "labRequestTests.assignUser.firstName",
        accessorFn: (row) =>
          `${row.labRequestTests.assignUser.firstName} ${row.labRequestTests.assignUser.lastName}`,
        header: "User",
        size: 80,
      },
    ],
    [],
  );

  const tableSubmitToEng = useMaterialReactTable({
    columns: columnsSubmitToEng,
    data: data,

    enableRowActions: true,
    positionActionsColumn: "last",

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows

      sx: {
        padding: "10px",
        backgroundColor:
          row.original.complete === true ? colors.greenAccent[800] : "#ffdb15",
      },
    }),

    renderRowActionMenuItems: ({ closeMenu, row }) => [
      <MenuItem
        key={1}
        onClick={() => {
          console.log("daaaa....", row.original);
          setSelectedRequestId(row.original);
          handleOpenReportPreview();
          closeMenu();
        }}
        startIcon={<Receipt color="success" />}
      >
        <Button
          variant="text"
          fullWidth
          startIcon={<Receipt color="success" />}
        >
          <Typography color="success" variant="subtitle1">
            View REPORT
          </Typography>
        </Button>
      </MenuItem>,
    ],
  });

  //---------------------------------------------------------------jobs at data entry-------------------------------------------

  //should be memoized or stable
  const columnsDataEntry = useMemo(
    () => [
      {
        accessorFn: (row) =>
          `${row.labRequest.year}/${String(
            row.labRequest.autoIdByYear,
          ).padStart(4, "0")}`,
        //accessorKey: "institute.instituteName", //access nested data with dot notation
        header: "Job No",
        size: 80,
      },
      {
        accessorKey: "labRequest.regDate",
        header: "Job Date",
        size: 80,
      },
      {
        accessorKey: "labRequest.institute.instituteName", //access nested data with dot notation
        header: "Institute / Contractor",
        size: 200,
      },
      {
        accessorKey: "labRequestTests.assignUser.firstName",
        accessorFn: (row) =>
          `${row.assignUser.firstName} ${row.assignUser.lastName}`,
        header: "Assigned TO",
        size: 80,
      },
    ],
    [],
  );

  const tableDataEntry = useMaterialReactTable({
    columns: columnsDataEntry,
    data: pendingRequestsDataEntry,

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows

      sx: {
        padding: "10px",
        backgroundColor:
          row.original.complete === true ? colors.greenAccent[800] : "#ffdb15",
      },
    }),

    renderRowActionMenuItems: ({ closeMenu, row }) => [
      <MenuItem
        key={1}
        onClick={() => {
          console.log("daaaa....", row.original);
          setSelectedRequestId(row.original);
          handleOpenReportPreview();
          closeMenu();
        }}
        startIcon={<Receipt color="success" />}
      >
        <Button
          variant="text"
          fullWidth
          startIcon={<Receipt color="success" />}
        >
          <Typography color="success" variant="subtitle1">
            View REPORT
          </Typography>
        </Button>
      </MenuItem>,
    ],
  });

  //---------------------------------------------------------------jobs at TO-------------------------------------------

  //should be memoized or stable
  const columnsTO = useMemo(
    () => [
      {
        accessorFn: (row) =>
          `${row.year}/${String(row.autoIdByYear).padStart(4, "0")}`,
        //accessorKey: "institute.instituteName", //access nested data with dot notation
        header: "Job No",
        size: 80,
      },
      {
        accessorKey: "regDate",
        header: "Job Date",
        size: 80,
      },
      {
        accessorKey: "instituteName", //access nested data with dot notation
        header: "Institute / Contractor",
        size: 200,
      },

      {
        accessorFn: (row) =>
          `QC/${row.reportType}/${row.year}/${String(row.id).padStart(4, "0")}`,
        header: "Report No",
        size: 80,
      },
      {
        accessorKey: "date",
        header: "Report Date",
        size: 80,
      },
      {
        accessorKey: "reportedDateTime",
        header: "Reported Date",
        accessorFn: (row) => `${row.finalizedDateTime}`,
        size: 80,
      },
      {
        accessorKey: "assignUser",
        header: "User",
        size: 80,
      },
    ],
    [],
  );

  const tableTO = useMaterialReactTable({
    columns: columnsTO,
    data: pendingRequestsTO,

    enableRowActions: true,
    positionActionsColumn: "last",

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows

      sx: {
        padding: "10px",
        backgroundColor:
          row.original.complete === true ? colors.greenAccent[800] : "#ffdb15",
      },
    }),

    renderRowActionMenuItems: ({ closeMenu, row }) => [
      <MenuItem
        key={1}
        onClick={() => {
          console.log("daaaa....", row.original);
          setSelectedRequestId(row.original);
          handleOpenReportPreview();
          closeMenu();
        }}
        startIcon={<Receipt color="success" />}
      >
        <Button
          variant="text"
          fullWidth
          startIcon={<Receipt color="success" />}
        >
          <Typography color="success" variant="subtitle1">
            View REPORT
          </Typography>
        </Button>
      </MenuItem>,
    ],
  });

  //---------------------------------------------------------------rejected reports-------------------------------------------

  //should be memoized or stable
  const columnsRejected = useMemo(
    () => [
      {
        accessorFn: (row) =>
          `${row.year}/${String(row.autoIdByYear).padStart(4, "0")}`,
        //accessorKey: "institute.instituteName", //access nested data with dot notation
        header: "Job No",
        size: 80,
      },
      {
        accessorKey: "regDate",
        header: "Job Date",
        size: 80,
      },
      {
        accessorKey: "instituteName", //access nested data with dot notation
        header: "Institute / Contractor",
        size: 200,
      },

      {
        accessorFn: (row) =>
          `QC/${row.reportType}/${row.year}/${String(row.id).padStart(4, "0")}`,
        header: "Report No",
        size: 80,
      },
      {
        accessorKey: "date",
        header: "Report Date",
        size: 80,
      },
      {
        accessorKey: "assignUser",
        // accessorFn: (row) =>
        //   `${row.labRequestTests.assignUser.firstName} ${row.labRequestTests.assignUser.lastName}`,
        header: "User",
        size: 80,
      },
    ],
    [],
  );

  const tableRejected = useMaterialReactTable({
    columns: columnsRejected,
    data: returnedReports,

    enableRowActions: true,
    positionActionsColumn: "last",

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows

      sx: {
        padding: "10px",
        backgroundColor:
          row.original.complete === true ? colors.greenAccent[800] : "#ffdb15",
      },
    }),

    renderRowActionMenuItems: ({ closeMenu, row }) => [
      <MenuItem
        key={1}
        onClick={() => {
          console.log("daaaa....", row.original);
          setSelectedRequestId(row.original);
          handleOpenReportPreview();
          closeMenu();
        }}
        startIcon={<Receipt color="success" />}
      >
        <Button
          variant="text"
          fullWidth
          startIcon={<Receipt color="success" />}
        >
          <Typography color="success" variant="subtitle1">
            View REPORT
          </Typography>
        </Button>
      </MenuItem>,
    ],
  });

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const rejectReport = async () => {
    setLoading(true);
    // console.log(
    //   "user id ",
    //   loggedUser.id,
    //   " -- " + rejectReason + " ppp ",
    //   selectedRequestId
    // );
    await axios
      .put(
        DATA_SAVE_URL +
          "/api/v1/labReq/rejectReport" +
          selectedRequestId.labRequestTests.id,
        null,
        {
          params: {
            userId: loggedUser.id,
            rejectReason: rejectReason,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      )
      .then(function (response) {
        // console.log(response.data);
        setOpenConfirmDialog(false);
        // setPendingCreditJobs(response.data.pendingRequests);
        // setData(response.data.submittedToEngineer);
        // setReturnedReports(response.data.returnedReports);
        setMessage("Report Un-Finalized successfully..!");
        setLoading(false);
        setMessageType("success");
        setOpen(true);
        // setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {" "}
      {loading ? <LoadingBackDrop openBackDrop={loading} /> : ""}
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            centered
          >
            <Tab
              sx={{ fontSize: "14px", fontWeight: 600 }}
              label="Pendig Reports"
              {...a11yProps(0)}
            />
            <Tab
              sx={{ fontSize: "14px", fontWeight: 600 }}
              label="Pending reports at Data entry"
              {...a11yProps(1)}
            />
            <Tab
              sx={{ fontSize: "14px", fontWeight: 600 }}
              label="Pending Jobs at TO"
              {...a11yProps(2)}
            />
            <Tab
              sx={{ fontSize: "14px", fontWeight: 600 }}
              label="Rejected Reports"
              {...a11yProps(3)}
            />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0} centered>
          <Paper
            sx={{ padding: "15px", borderRadius: "8px", width: "95%" }}
            elevation={3}
          >
            <Box display="flex" justifyContent="space-between">
              <Header title="Authorize Job" subtitle="Pending Reports" />
              <Box
                sx={{
                  textAlign: "center",
                  alignContent: "center",
                }}
              >
                <Typography
                  color={colors.redAccent[500]}
                  alignContent="center"
                  variant="h3"
                ></Typography>
              </Box>
            </Box>
            {completedJobs?.map((data, index) => (
              <JobAuthorizeComponent
                key={index}
                colors={colors}
                isNonMobile={isNonMobile}
                setOpen={setOpen}
                setMessage={setMessage}
                setMessageType={setMessageType}
                data={data}
                loading={loading}
                setLoading={setLoading}
                setSelectedRequestId={setSelectedRequestId}
                handleOpenReportPreview={handleOpenReportPreview}
                setApproveDate={setApproveDate}
                apprveSelectedRequestDB={apprveSelectedRequestDB}
                setCheckedReport={setCheckedReport}
                setOpenConfirmDialog={setOpenConfirmDialog}
                setConfirmMessage={setConfirmMessage}
                // loggedUser={loggedUser}
              />
            ))}
          </Paper>
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1} centered>
          <Paper
            sx={{
              padding: "15px",
              borderRadius: "8px",
              width: "95%",
              marginTop: "15px",
            }}
            elevation={3}
          >
            <Header
              title="Pending reports at data entry"
              subtitle="Save / Update"
            />

            <MaterialReactTable table={tableDataEntry} />
          </Paper>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2} centered>
          <Paper
            sx={{
              padding: "15px",
              borderRadius: "8px",
              width: "95%",
              marginTop: "15px",
            }}
            elevation={3}
          >
            <Header
              title="Pending reports at T.O / A.T.O"
              subtitle="Save / Update"
            />
            <MaterialReactTable table={tableTO} />
          </Paper>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3} centered>
          <Paper
            sx={{
              padding: "15px",
              borderRadius: "8px",
              width: "95%",
              marginTop: "15px",
            }}
            elevation={3}
          >
            <Header
              title="Rejected reports by Engineer / T.O / A.T.O "
              subtitle="Save / Update"
            />
            <MaterialReactTable table={tableRejected} />
          </Paper>
        </CustomTabPanel>
      </Box>
      {/* <ReportDialog
        colors={colors}
        isNonMobile={isNonMobile}
        handleOpenReportPreview={handleOpenReportPreview}
        handleCloseReportPreview={handleCloseReportPreview}
        open={openReportPreviewDialog}
        data={selectedRequestId}
        letterHead={letterHead}
      /> */}
      <PDFViewerDialog
        reportNo={`QC_${selectedRequestId?.reportType}_${
          selectedRequestId?.labRequest?.year
        }_${String(selectedRequestId?.autoIdByYear).padStart(4, "0")}`}
        labRequestId={selectedRequestId?.barcode}
        open={openReportPreviewDialog}
        handleCloseReportPreview={handleCloseReportPreview}
        reportType={"REPORT"}
        letterHead={true}
      />
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
      <ConfirmationDialog
        confirmationMessage={confirmMessage}
        openConfirmDialog={openConfirmDialog}
        handleCloseDialog={handleCloseDialog}
        messageTitle={
          checkedReport === "APPROVE" ? "APPROVE REPORT" : "REJECT REPORT"
        }
        dialogFunction={
          checkedReport === "APPROVE" ? apprveSelectedRequestDB : rejectReport
        }
        setRejectReason={setRejectReason}
      />
    </Box>
  );
};

export default JobAuthorize;
